module.exports = __webpack_public_path__ + "img/surhabitat.63ff88ab.png";